<template>
  <div class="base-popup-title">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/font";
@use "@/styles/variables/colors";

.base-popup-title {
  padding-left: 10px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid colors.$border-subtle;
  font-weight: font.$weight-bold;
  font-size: 12px;
  line-height: 15px;
  color: colors.$text-subtle;
  padding-top: 10px;
  padding-bottom: 10px;
  outline: revert;
}
</style>
